import SignatureDialog from './SignatureDialog';
export var FORMS_MODALS = {
  SIGNATURE_DIALOG: SignatureDialog
};
export default FORMS_MODALS;